import { Component, forwardRef } from "react";

type CommonDrawerProps = React.HtmlHTMLAttributes<HTMLDivElement>;

function DrawerHeader(props: CommonDrawerProps, ref: React.Ref<HTMLDivElement>) {
	return <div {...props} ref={ref} />;
}

function DrawerBody(props: CommonDrawerProps, ref: React.Ref<HTMLDivElement>) {
	return <div {...props} ref={ref} />;
}

function DrawerFooter(props: CommonDrawerProps, ref: React.Ref<HTMLDivElement>) {
	return <div {...props} ref={ref} />;
}

class DrawerComp extends Component<React.PropsWithChildren> {
	static Header = forwardRef(DrawerHeader);
	static Body = forwardRef(DrawerBody);
	static Footer = forwardRef(DrawerFooter);
	render() {
		return this.props.children;
	}
}

export default DrawerComp;
